import { postRequest } from "./request";

export function LoadVessel(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `get-client-lists`,
    token: userData.token,
  }).then((response) => {
    return response ? response : undefined;
  });
}
